import './index.css'
import {Redirect, Link} from 'react-router-dom'
import Cookies from 'js-cookie'
import {formatDistanceToNow} from 'date-fns'

import {RiPlayListAddFill} from 'react-icons/ri'
import Header from '../Header'
import ThemeContext from '../ThemeContext'
import LeftPortion from '../LeftPortion'



const SavedVideoCard = ({videoDetails, theme}) => {
  const {id, title, thumbnailUrl, channel, viewCount, publishedAt} =
    videoDetails
  const publishedDate = formatDistanceToNow(new Date(publishedAt))

  return (
    <li className="saved-video-card-list-item">
      <Link to={`/videos/${id}`} className="saved-video-card-link">
        <img
          src={thumbnailUrl}
          className="saved-video-card-thumbnail"
          alt="video thumbnail"
        />
        <div className="saved-video-card-details">
          <p className={`saved-video-card-title ${theme}`}>{title}</p>
          <p className="saved-video-card-channel-name">{channel.name}</p>
          <div className="saved-video-card-stats">
            <p>{viewCount} views</p>
            <p className="dot-separator">•</p>
            <p>{publishedDate} ago</p>
          </div>
        </div>
      </Link>
    </li>
  )
}


const NoSavedVideosView = () => (
  <div className="no-saved-videos-view">
    <img
      alt="no saved videos"
      className="no-saved-videos-image"
      src="https://assets.ccbp.in/frontend/react-js/nxt-watch-no-saved-videos-img.png"
    />
    <h1>No saved videos found</h1>
    <p>You can save your videos while watching them</p>
  </div>
)

const SavedVideo = () => {
  const token = Cookies.get('jwt_token')
  if (token === undefined) {
    return <Redirect to="/login" />
  }

  return (
    <ThemeContext.Consumer>
      {value => {
        const {activeThemeIsLight, savedVideos} = value
        const theme = activeThemeIsLight ? 'light-theme' : 'dark-theme'

        return (
          <>
            <Header />
            <div className="page-container" data-testid="savedVideos">
              <LeftPortion />
              <div className={`content-container ${theme}`}>
                <div className="page-header" data-testid="banner">
                  <div className="page-icon-container">
                    <RiPlayListAddFill size={24} color="#ff0000" />
                  </div>
                  <h1>Saved Videos</h1>
                </div>
                <div className="content-body">
                  {savedVideos.length === 0 ? (
                    <NoSavedVideosView />
                  ) : (
                    <ul className="saved-videos-list-container">
                      {savedVideos.map(each => (
                        <SavedVideoCard
                          key={each.id}
                          videoDetails={each}
                          theme={theme}
                        />
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </>
        )
      }}
    </ThemeContext.Consumer>
  )
}

export default SavedVideo
